// 注文の確定

import apiFactory from '../api-factory'

import bodyMapper from '../sale/order-body-mapper'

const V2_BASE_URL = process.env.VUE_APP_API_V2_BRIDGE_BASE_URL || '/api/v2-bridge'

export default apiFactory({
  path: `${V2_BASE_URL}/orders/commit?saleId=<%= id %>&amount=<%= amount %>&paymentFlowId=<%= paymentFlowId %>`,
  method: 'POST',
  expectedParams: ['id', 'amount', 'paymentFlowId'],
  needAuth: true,
  bodyMapper,
})
